import { store } from "../store";
import { handleUnauthorizedError } from "./apiMiddleware";
import { Project } from "./retailerApi";

const API_URL = `${import.meta.env.VITE_API_URL || "http://localhost:5000/api"}/projects`;

const getAuthHeader = (): Record<string, string> => {
  const token = store.getState().user?.currentUser?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getProjects = async (): Promise<Project[]> => {
  const response = await fetch(API_URL, {
    headers: getAuthHeader(),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors de la récupération des projets");
  return response.json();
};

export const createProjectGlobal = async (project: Partial<Project>): Promise<Project> => {
  const response = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(project),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors de la création du projet");
  return response.json();
};

export const updateProjectGlobal = async (projectId: string, project: Partial<Project>): Promise<Project> => {
  const response = await fetch(`${API_URL}/${projectId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(project),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors de la mise à jour du projet");
  return response.json();
};

export const deleteProjectGlobal = async (projectId: string): Promise<void> => {
  const response = await fetch(`${API_URL}/${projectId}`, {
    method: "DELETE",
    headers: getAuthHeader(),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors de la suppression du projet");
};

export const uploadProjectAttachment = async (
  projectId: string,
  payload: { fileName: string; contentType?: string; data: string }
): Promise<Project> => {
  const response = await fetch(`${API_URL}/${projectId}/attachments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors de l'upload du document");
  return response.json();
};

export const deleteProjectAttachment = async (projectId: string, itemId: string): Promise<Project> => {
  const response = await fetch(`${API_URL}/${projectId}/attachments/${itemId}`, {
    method: "DELETE",
    headers: getAuthHeader(),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors de la suppression du document");
  return response.json();
};

export const fetchProjectAttachmentBlob = async (projectId: string, itemId: string): Promise<Blob> => {
  const response = await fetch(`${API_URL}/${projectId}/attachments/${itemId}`, {
    headers: getAuthHeader(),
  });
  if (handleUnauthorizedError(response)) throw new Error("Session expirée");
  if (!response.ok) throw new Error("Erreur lors du chargement du document");
  return response.blob();
};
